import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  searchQuestionWithTerm,
  searchProfileWithTerm,
  searchProductWithTerm,
  searchOpinionWithTerm,
} from 'app/dispatcher/searchDispatcher';
import { configureStaticPageHead } from 'app/utils/configurePageHead';
import { PAGE_TYPE } from 'app/constants/app';
import get from 'lodash/get';
import Page from 'app/components/misc/BasePage';
import PageHead from 'app/components/misc/PageHead';
import SearchContent from 'app/pageContents/SearchContent';
import { Colors } from 'app/seedly-component-library';

const Search = props => {
  const { searchTerm } = props;

  const dispatch = useDispatch();

  const urlify = (searchTermParam = '') => {
    return searchTermParam.trim().replace(/\s/g, '%20');
  };

  // Effects
  useEffect(() => {
    dispatch(searchQuestionWithTerm({ term: searchTerm }));
    dispatch(searchProfileWithTerm({ term: searchTerm }));
    dispatch(searchProductWithTerm({ term: searchTerm }));
    dispatch(searchOpinionWithTerm({ term: searchTerm }));
  }, []);

  return (
    <Page
      pageContentStyle={{
        backgroundColor: Colors.neutral2,
      }}
    >
      <PageHead
        {...configureStaticPageHead(PAGE_TYPE.SEARCH, urlify(searchTerm))}
      />
      <SearchContent searchTerm={searchTerm} />
    </Page>
  );
};

Search.getInitialProps = async ({ query }) => {
  try {
    const searchTerm = get(query, 's', '');
    return {
      searchTerm,
    };
  } catch (error) {
    // This should goes to sentry, allowing console log for now
    console.log(error);
  }

  return {};
};

export default Search;
